module.exports = __webpack_public_path__ + "img/MU.d9d5ba49.svg";